import React from 'react'
import './App.css';
import { Outlet, useLocation } from 'react-router-dom';
import { useActivityLog } from './hooks/useActivityLog';
import AuthHeader from './Components/AuthHeader/AuthHeader';

const AUTH_PATHS = ['/login', '/login/mentor', '/register', '/register/mentor'];

function Layer() {
  useActivityLog();
  const location = useLocation();
  const showAuthHeader = AUTH_PATHS.includes(location.pathname);

  return (
    <div className='layer'>
      {showAuthHeader && <AuthHeader />}
      <Outlet />
    </div>
  )
}

export default Layer